package ui.consumerInformation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import model.MerchantFullInformationV3
import ui.scrollbar.LazyColumnScrollbar

@Composable
fun ConsumerInformationScreen(
    viewModel: ConsumerInformationViewModel = consumerInformationViewModel(),
    merchantCardView: @Composable (MerchantFullInformationV3, (MerchantFullInformationV3) -> Unit) -> Unit,
) {
    val _consumerInformation by viewModel.consumerInformationStateFlow.collectAsState()
    val consumerInformation = _consumerInformation
    val shouldShowScrollbar = viewModel.clientConfig.shouldShowScrollBar

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val lazyListState = rememberLazyListState()

        if (consumerInformation != null) {
            LazyColumnScrollbar(
                listState = lazyListState,
                padding = 4.dp,
                alwaysShowScrollBar = shouldShowScrollbar,
            ) {
                LazyColumn(
                    state = lazyListState,
                    modifier = Modifier
                ) {
                    item {
                        Text(
                            modifier = Modifier.fillMaxWidth(),
                            text = "Loyalty Member",
                            fontSize = 25.sp,
                            fontWeight = FontWeight.Bold,
                            textAlign = TextAlign.Center,
                        )
                        Spacer(Modifier.height(8.dp))
                        ConsumerInformationDisplay(consumerInformation)
                        ConsumerCardDisplay(consumerInformation.cards.filterNotNull(), shouldShowScrollbar)
                        Text(
                            "My Stores",
                            fontWeight = FontWeight.ExtraBold,
                            modifier = Modifier.align(Alignment.Start).padding(start = 16.dp, top = 16.dp, bottom = 16.dp),
                            fontSize = 20.sp
                        )
                    }
                    ConsumerStoreInformationDisplay(
                        consumerInformation.merchants.filterNotNull(),
                        merchantCardView,
                        viewModel::setMerchant
                    )
                    item {
                        ReferProgramCardView()
                    }
                }
            }
        } else {
            CircularProgressIndicator()
        }
    }
}